/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IAccountClient {
    /**
     * @return OK
     */
    get(debtorNumber: string,  cancelToken?: CancelToken): Promise<ApiResultOfIEnumerableOfAccountDto>;
}

export class AccountClient implements IAccountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:44326";

    }

    /**
     * @return OK
     */
    get(debtorNumber: string, cancelToken?: CancelToken): Promise<ApiResultOfIEnumerableOfAccountDto> {
        let url_ = this.baseUrl + "/api/Account?";
        if (debtorNumber === undefined || debtorNumber === null)
            throw new globalThis.Error("The parameter 'debtorNumber' must be defined and cannot be null.");
        else
            url_ += "DebtorNumber=" + encodeURIComponent("" + debtorNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ApiResultOfIEnumerableOfAccountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200) {
                    pushIfNotNull(result200, AccountDto.fromJS(item, _mappings));
                }
            } else {
                result200 = null as any;
            }
            return Promise.resolve<ApiResultOfIEnumerableOfAccountDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("NotFound", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfIEnumerableOfAccountDto>(null as any);
    }
}

export interface IAssessorClient {
    /**
     * Gets the logged in assessor's name and other profile information.
     * @return OK
     */
    me( cancelToken?: CancelToken): Promise<AssessorProfileDto>;
}

export class AssessorClient implements IAssessorClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:44326";

    }

    /**
     * Gets the logged in assessor's name and other profile information.
     * @return OK
     */
    me( cancelToken?: CancelToken): Promise<AssessorProfileDto> {
        let url_ = this.baseUrl + "/api/assessor/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: AxiosResponse): Promise<AssessorProfileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = AssessorProfileDto.fromJS(resultData200, _mappings);
            return Promise.resolve<AssessorProfileDto>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssessorProfileDto>(null as any);
    }
}

export interface IHealthClient {
    /**
     * @return OK
     */
    get( cancelToken?: CancelToken): Promise<any>;
}

export class HealthClient implements IHealthClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:44326";

    }

    /**
     * @return OK
     */
    get( cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/api/Health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}

export interface IResultClient {
    /**
     * Add Result Collection.  This is used by Unit Standard.
     * @return OK
     */
    post(requestList: CreateResultRequestDto[],  cancelToken?: CancelToken): Promise<ApiResultOfIListOfCreateResultResponseDto>;
    /**
     * Search Results.
     * @param dateEnteredFrom (optional) 
     * @param dateEnteredTo (optional) 
     * @return OK
     */
    get(dateEnteredFrom?: string | null | undefined, dateEnteredTo?: string | null | undefined,  cancelToken?: CancelToken): Promise<ApiResultOfIEnumerableOfResultDto>;
    /**
     * Add Result. This is used by Casual Credit, saving single result
     * @return OK
     */
    post2(request: CreateResultRequestDto,  cancelToken?: CancelToken): Promise<ApiResultOfCreateResultResponseDto>;
}

export class ResultClient implements IResultClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:44326";

    }

    /**
     * Add Result Collection.  This is used by Unit Standard.
     * @return OK
     */
    post(requestList: CreateResultRequestDto[], cancelToken?: CancelToken): Promise<ApiResultOfIListOfCreateResultResponseDto> {
        let url_ = this.baseUrl + "/api/result/multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestList);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<ApiResultOfIListOfCreateResultResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = ApiResultOfIListOfCreateResultResponseDto.fromJS(resultData200, _mappings);
            return Promise.resolve<ApiResultOfIListOfCreateResultResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfIListOfCreateResultResponseDto>(null as any);
    }

    /**
     * Search Results.
     * @param dateEnteredFrom (optional) 
     * @param dateEnteredTo (optional) 
     * @return OK
     */
    get(dateEnteredFrom?: string | null | undefined, dateEnteredTo?: string | null | undefined, cancelToken?: CancelToken): Promise<ApiResultOfIEnumerableOfResultDto> {
        let url_ = this.baseUrl + "/api/Result?";
        if (dateEnteredFrom !== undefined && dateEnteredFrom !== null)
            url_ += "DateEnteredFrom=" + encodeURIComponent("" + dateEnteredFrom) + "&";
        if (dateEnteredTo !== undefined && dateEnteredTo !== null)
            url_ += "DateEnteredTo=" + encodeURIComponent("" + dateEnteredTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ApiResultOfIEnumerableOfResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = ApiResultOfIEnumerableOfResultDto.fromJS(resultData200, _mappings);
            return Promise.resolve<ApiResultOfIEnumerableOfResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfIEnumerableOfResultDto>(null as any);
    }

    /**
     * Add Result. This is used by Casual Credit, saving single result
     * @return OK
     */
    post2(request: CreateResultRequestDto, cancelToken?: CancelToken): Promise<ApiResultOfCreateResultResponseDto> {
        let url_ = this.baseUrl + "/api/Result";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost2(_response);
        });
    }

    protected processPost2(response: AxiosResponse): Promise<ApiResultOfCreateResultResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = ApiResultOfCreateResultResponseDto.fromJS(resultData200, _mappings);
            return Promise.resolve<ApiResultOfCreateResultResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfCreateResultResponseDto>(null as any);
    }
}

export interface IScopeClient {
    /**
     * Search scopes.
     * @param unitStandard (optional) 
     * @return OK
     */
    get(unitStandard?: string | null | undefined,  cancelToken?: CancelToken): Promise<SearchScopeResultDto>;
}

export class ScopeClient implements IScopeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:44326";

    }

    /**
     * Search scopes.
     * @param unitStandard (optional) 
     * @return OK
     */
    get(unitStandard?: string | null | undefined, cancelToken?: CancelToken): Promise<SearchScopeResultDto> {
        let url_ = this.baseUrl + "/api/Scope?";
        if (unitStandard !== undefined && unitStandard !== null)
            url_ += "unitStandard=" + encodeURIComponent("" + unitStandard) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SearchScopeResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SearchScopeResultDto.fromJS(resultData200, _mappings);
            return Promise.resolve<SearchScopeResultDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchScopeResultDto>(null as any);
    }
}

export interface ITrainingPlanClient {
    /**
     * Gets a list of all training plans where logged in user is the assessor
     * @return OK
     */
    myTrainingPlans( cancelToken?: CancelToken): Promise<TrainingPlanDto[]>;
    /**
     * Search training plans where {query} is matched against either of Training Plan ID or NSN
     * @param query search string
     * @return OK
     */
    searchTrainingPlans(query: string,  cancelToken?: CancelToken): Promise<TrainingPlanDto[]>;
}

export class TrainingPlanClient implements ITrainingPlanClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:44326";

    }

    /**
     * Gets a list of all training plans where logged in user is the assessor
     * @return OK
     */
    myTrainingPlans( cancelToken?: CancelToken): Promise<TrainingPlanDto[]> {
        let url_ = this.baseUrl + "/api/trainingplan/my";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMyTrainingPlans(_response);
        });
    }

    protected processMyTrainingPlans(response: AxiosResponse): Promise<TrainingPlanDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingPlanDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TrainingPlanDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingPlanDto[]>(null as any);
    }

    /**
     * Search training plans where {query} is matched against either of Training Plan ID or NSN
     * @param query search string
     * @return OK
     */
    searchTrainingPlans(query: string, cancelToken?: CancelToken): Promise<TrainingPlanDto[]> {
        let url_ = this.baseUrl + "/api/trainingplan/search?";
        if (query === undefined || query === null)
            throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchTrainingPlans(_response);
        });
    }

    protected processSearchTrainingPlans(response: AxiosResponse): Promise<TrainingPlanDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingPlanDto.fromJS(item, _mappings));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TrainingPlanDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingPlanDto[]>(null as any);
    }
}

export interface ITrainingPlanUnitStandardClient {
    /**
     * Search training plan unit standards.
     * @param trainingPlanId (optional) 
     * @return OK
     */
    get(trainingPlanId?: string | null | undefined,  cancelToken?: CancelToken): Promise<TrainingPlanUnitStandardDto[]>;
}

export class TrainingPlanUnitStandardClient implements ITrainingPlanUnitStandardClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:44326";

    }

    /**
     * Search training plan unit standards.
     * @param trainingPlanId (optional) 
     * @return OK
     */
    get(trainingPlanId?: string | null | undefined, cancelToken?: CancelToken): Promise<TrainingPlanUnitStandardDto[]> {
        let url_ = this.baseUrl + "/api/TrainingPlanUnitStandard?";
        if (trainingPlanId !== undefined && trainingPlanId !== null)
            url_ += "TrainingPlanId=" + encodeURIComponent("" + trainingPlanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<TrainingPlanUnitStandardDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200) {
                    pushIfNotNull(result200, TrainingPlanUnitStandardDto.fromJS(item, _mappings));
                }
            } else {
                result200 = null as any;
            }
            return Promise.resolve<TrainingPlanUnitStandardDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingPlanUnitStandardDto[]>(null as any);
    }
}

export interface IUnitStandardClient {
    /**
     * @return OK
     */
    get(code: number,  cancelToken?: CancelToken): Promise<ApiResultOfUnitStandardDto>;
}

export class UnitStandardClient implements IUnitStandardClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:44326";

    }

    /**
     * @return OK
     */
    get(code: number, cancelToken?: CancelToken): Promise<ApiResultOfUnitStandardDto> {
        let url_ = this.baseUrl + "/api/UnitStandard?";
        if (code === undefined || code === null)
            throw new globalThis.Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ApiResultOfUnitStandardDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = ApiResultOfUnitStandardDto.fromJS(resultData200, _mappings);
            return Promise.resolve<ApiResultOfUnitStandardDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("NotFound", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfUnitStandardDto>(null as any);
    }
}

export interface IUnitStandardVersionClient {
    /**
     * @return OK
     */
    get(code: string,  cancelToken?: CancelToken): Promise<ApiResultOfUnitStandardVersionsDto>;
}

export class UnitStandardVersionClient implements IUnitStandardVersionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:44326";

    }

    /**
     * @return OK
     */
    get(code: string, cancelToken?: CancelToken): Promise<ApiResultOfUnitStandardVersionsDto> {
        let url_ = this.baseUrl + "/api/UnitStandardVersion?";
        if (code === undefined || code === null || code.trim() === '')
            throw new globalThis.Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent(code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ApiResultOfUnitStandardVersionsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = ApiResultOfUnitStandardVersionsDto.fromJS(resultData200, _mappings);
            return Promise.resolve<ApiResultOfUnitStandardVersionsDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("BadRequest", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("NotFound", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("InternalServerError", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultOfUnitStandardVersionsDto>(null as any);
    }
}

export class ApiResultOfIEnumerableOfAccountDto implements IApiResultOfIEnumerableOfAccountDto {
    result?: AccountDto[] | undefined;
    message?: string | undefined;

    constructor(data?: IApiResultOfIEnumerableOfAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.result) {
                this.result = [];
                for (let i = 0; i < data.result.length; i++) {
                    let item = data.result[i];
                    this.result[i] = item && !(item as any).toJSON ? new AccountDto(item) : item as AccountDto;
                }
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    pushIfNotNull(this.result!, AccountDto.fromJS(item, _mappings));
            }
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any, _mappings?: any): ApiResultOfIEnumerableOfAccountDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ApiResultOfIEnumerableOfAccountDto>(data, _mappings, ApiResultOfIEnumerableOfAccountDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item ? item.toJSON() : undefined as any);
        }
        data["Message"] = this.message;
        return data;
    }

    clone(): ApiResultOfIEnumerableOfAccountDto {
        const json = this.toJSON();
        let result = new ApiResultOfIEnumerableOfAccountDto();
        result.init(json);
        return result;
    }
}

export interface IApiResultOfIEnumerableOfAccountDto {
    result?: IAccountDto[] | undefined;
    message?: string | undefined;
}

export class AccountDto implements IAccountDto {
    accountName?: string | undefined;
    debtorNumber?: string | undefined;

    constructor(data?: IAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.accountName = _data["AccountName"];
            this.debtorNumber = _data["DebtorNumber"];
        }
    }

    static fromJS(data: any, _mappings?: any): AccountDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AccountDto>(data, _mappings, AccountDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountName"] = this.accountName;
        data["DebtorNumber"] = this.debtorNumber;
        return data;
    }

    clone(): AccountDto {
        const json = this.toJSON();
        let result = new AccountDto();
        result.init(json);
        return result;
    }
}

export interface IAccountDto {
    accountName?: string | undefined;
    debtorNumber?: string | undefined;
}

export class AssessorProfileDto implements IAssessorProfileDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    rccAssessmentAllowed?: boolean | undefined;

    constructor(data?: IAssessorProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.rccAssessmentAllowed = _data["RccAssessmentAllowed"];
        }
    }

    static fromJS(data: any, _mappings?: any): AssessorProfileDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AssessorProfileDto>(data, _mappings, AssessorProfileDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["RccAssessmentAllowed"] = this.rccAssessmentAllowed;
        return data;
    }

    clone(): AssessorProfileDto {
        const json = this.toJSON();
        let result = new AssessorProfileDto();
        result.init(json);
        return result;
    }
}

export interface IAssessorProfileDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    rccAssessmentAllowed?: boolean | undefined;
}

export class CreateResultRequestDto implements ICreateResultRequestDto {
    assessorId?: string | undefined;
    traineeId?: string | undefined;
    unitStandardId?: string | undefined;
    trainingPlanUnitStandardId?: string | undefined;
    unitStandardCode?: string | undefined;
    unitStandardName?: string | undefined;
    isExistingResult?: boolean | undefined;
    dateAchieved?: string | undefined;
    dateEntered?: string | undefined;
    statusCode?: number | undefined;
    isRcc?: boolean | undefined;
    casualCredit?: boolean | undefined;
    debtorCode?: string | undefined;
    poNumber?: string | undefined;

    constructor(data?: ICreateResultRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.assessorId = _data["AssessorId"];
            this.traineeId = _data["TraineeId"];
            this.unitStandardId = _data["UnitStandardId"];
            this.trainingPlanUnitStandardId = _data["TrainingPlanUnitStandardId"];
            this.unitStandardCode = _data["UnitStandardCode"];
            this.unitStandardName = _data["UnitStandardName"];
            this.isExistingResult = _data["IsExistingResult"];
            this.dateAchieved = _data["DateAchieved"];
            this.dateEntered = _data["DateEntered"];
            this.statusCode = _data["StatusCode"];
            this.isRcc = _data["IsRcc"];
            this.casualCredit = _data["CasualCredit"];
            this.debtorCode = _data["DebtorCode"];
            this.poNumber = _data["PoNumber"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateResultRequestDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateResultRequestDto>(data, _mappings, CreateResultRequestDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AssessorId"] = this.assessorId;
        data["TraineeId"] = this.traineeId;
        data["UnitStandardId"] = this.unitStandardId;
        data["TrainingPlanUnitStandardId"] = this.trainingPlanUnitStandardId;
        data["UnitStandardCode"] = this.unitStandardCode;
        data["UnitStandardName"] = this.unitStandardName;
        data["IsExistingResult"] = this.isExistingResult;
        data["DateAchieved"] = this.dateAchieved;
        data["DateEntered"] = this.dateEntered;
        data["StatusCode"] = this.statusCode;
        data["IsRcc"] = this.isRcc;
        data["CasualCredit"] = this.casualCredit;
        data["DebtorCode"] = this.debtorCode;
        data["PoNumber"] = this.poNumber;
        return data;
    }

    clone(): CreateResultRequestDto {
        const json = this.toJSON();
        let result = new CreateResultRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICreateResultRequestDto {
    assessorId?: string | undefined;
    traineeId?: string | undefined;
    unitStandardId?: string | undefined;
    trainingPlanUnitStandardId?: string | undefined;
    unitStandardCode?: string | undefined;
    unitStandardName?: string | undefined;
    isExistingResult?: boolean | undefined;
    dateAchieved?: string | undefined;
    dateEntered?: string | undefined;
    statusCode?: number | undefined;
    isRcc?: boolean | undefined;
    casualCredit?: boolean | undefined;
    debtorCode?: string | undefined;
    poNumber?: string | undefined;
}

export class ApiResultOfIListOfCreateResultResponseDto implements IApiResultOfIListOfCreateResultResponseDto {
    result?: CreateResultResponseDto[] | undefined;
    message?: string | undefined;

    constructor(data?: IApiResultOfIListOfCreateResultResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.result) {
                this.result = [];
                for (let i = 0; i < data.result.length; i++) {
                    let item = data.result[i];
                    this.result[i] = item && !(item as any).toJSON ? new CreateResultResponseDto(item) : item as CreateResultResponseDto;
                }
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"]) {
                    pushIfNotNull(this.result!, CreateResultResponseDto.fromJS(item, _mappings));
                }
            }
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any, _mappings?: any): ApiResultOfIListOfCreateResultResponseDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ApiResultOfIListOfCreateResultResponseDto>(data, _mappings, ApiResultOfIListOfCreateResultResponseDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item ? item.toJSON() : undefined as any);
        }
        data["Message"] = this.message;
        return data;
    }

    clone(): ApiResultOfIListOfCreateResultResponseDto {
        const json = this.toJSON();
        let result = new ApiResultOfIListOfCreateResultResponseDto();
        result.init(json);
        return result;
    }
}

export interface IApiResultOfIListOfCreateResultResponseDto {
    result?: ICreateResultResponseDto[] | undefined;
    message?: string | undefined;
}

export class CreateResultResponseDto implements ICreateResultResponseDto {
    resultId?: string | undefined;
    crmSaveErrorMessage?: string | undefined;
    crmSaveStatus?: CreateResultResponseDtoCrmSaveStatus | undefined;
    assessorId?: string | undefined;
    traineeId?: string | undefined;
    unitStandardId?: string | undefined;
    unitStandardCode?: string | undefined;
    unitStandardName?: string | undefined;
    isExistingResult?: boolean | undefined;
    dateAchieved?: string | undefined;
    dateEntered?: string | undefined;
    statusCode?: number | undefined;
    isRcc?: boolean | undefined;
    casualCredit?: boolean | undefined;
    debtorCode?: string | undefined;
    poNumber?: string | undefined;

    constructor(data?: ICreateResultResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.resultId = _data["ResultId"];
            this.crmSaveErrorMessage = _data["CrmSaveErrorMessage"];
            this.crmSaveStatus = _data["CrmSaveStatus"];
            this.assessorId = _data["AssessorId"];
            this.traineeId = _data["TraineeId"];
            this.unitStandardId = _data["UnitStandardId"];
            this.unitStandardCode = _data["UnitStandardCode"];
            this.unitStandardName = _data["UnitStandardName"];
            this.isExistingResult = _data["IsExistingResult"];
            this.dateAchieved = _data["DateAchieved"];
            this.dateEntered = _data["DateEntered"];
            this.statusCode = _data["StatusCode"];
            this.isRcc = _data["IsRcc"];
            this.casualCredit = _data["CasualCredit"];
            this.debtorCode = _data["DebtorCode"];
            this.poNumber = _data["PoNumber"];
        }
    }

    static fromJS(data: any, _mappings?: any): CreateResultResponseDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateResultResponseDto>(data, _mappings, CreateResultResponseDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ResultId"] = this.resultId;
        data["CrmSaveErrorMessage"] = this.crmSaveErrorMessage;
        data["CrmSaveStatus"] = this.crmSaveStatus;
        data["AssessorId"] = this.assessorId;
        data["TraineeId"] = this.traineeId;
        data["UnitStandardId"] = this.unitStandardId;
        data["UnitStandardCode"] = this.unitStandardCode;
        data["UnitStandardName"] = this.unitStandardName;
        data["IsExistingResult"] = this.isExistingResult;
        data["DateAchieved"] = this.dateAchieved;
        data["DateEntered"] = this.dateEntered;
        data["StatusCode"] = this.statusCode;
        data["IsRcc"] = this.isRcc;
        data["CasualCredit"] = this.casualCredit;
        data["DebtorCode"] = this.debtorCode;
        data["PoNumber"] = this.poNumber;
        return data;
    }

    clone(): CreateResultResponseDto {
        const json = this.toJSON();
        let result = new CreateResultResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICreateResultResponseDto {
    resultId?: string | undefined;
    crmSaveErrorMessage?: string | undefined;
    crmSaveStatus?: CreateResultResponseDtoCrmSaveStatus | undefined;
    assessorId?: string | undefined;
    traineeId?: string | undefined;
    unitStandardId?: string | undefined;
    unitStandardCode?: string | undefined;
    unitStandardName?: string | undefined;
    isExistingResult?: boolean | undefined;
    dateAchieved?: string | undefined;
    dateEntered?: string | undefined;
    statusCode?: number | undefined;
    isRcc?: boolean | undefined;
    casualCredit?: boolean | undefined;
    debtorCode?: string | undefined;
    poNumber?: string | undefined;
}

export class ApiResultOfIEnumerableOfResultDto implements IApiResultOfIEnumerableOfResultDto {
    result?: ResultDto[] | undefined;
    message?: string | undefined;

    constructor(data?: IApiResultOfIEnumerableOfResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.result) {
                this.result = [];
                for (let i = 0; i < data.result.length; i++) {
                    let item = data.result[i];
                    this.result[i] = item && !(item as any).toJSON ? new ResultDto(item) : item as ResultDto;
                }
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"]) {
                    pushIfNotNull(this.result!, ResultDto.fromJS(item, _mappings));
                }
            }
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any, _mappings?: any): ApiResultOfIEnumerableOfResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ApiResultOfIEnumerableOfResultDto>(data, _mappings, ApiResultOfIEnumerableOfResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item ? item.toJSON() : undefined as any);
        }
        data["Message"] = this.message;
        return data;
    }

    clone(): ApiResultOfIEnumerableOfResultDto {
        const json = this.toJSON();
        let result = new ApiResultOfIEnumerableOfResultDto();
        result.init(json);
        return result;
    }
}

export interface IApiResultOfIEnumerableOfResultDto {
    result?: IResultDto[] | undefined;
    message?: string | undefined;
}

export class ResultDto implements IResultDto {
    resultId?: string | undefined;
    dateEntered?: string | undefined;
    dateAchieved?: string | undefined;
    trainingPlanId?: string | undefined;
    frameworkElementCode?: string | undefined;
    version?: number | undefined;
    traineeId?: string | undefined;
    traineeFirstName?: string | undefined;
    traineeLastName?: string | undefined;
    traineeNSN?: string | undefined;

    constructor(data?: IResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.resultId = _data["ResultId"];
            this.dateEntered = _data["DateEntered"];
            this.dateAchieved = _data["DateAchieved"];
            this.trainingPlanId = _data["TrainingPlanId"];
            this.frameworkElementCode = _data["FrameworkElementCode"];
            this.version = _data["Version"];
            this.traineeId = _data["TraineeId"];
            this.traineeFirstName = _data["TraineeFirstName"];
            this.traineeLastName = _data["TraineeLastName"];
            this.traineeNSN = _data["TraineeNSN"];
        }
    }

    static fromJS(data: any, _mappings?: any): ResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ResultDto>(data, _mappings, ResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ResultId"] = this.resultId;
        data["DateEntered"] = this.dateEntered;
        data["DateAchieved"] = this.dateAchieved;
        data["TrainingPlanId"] = this.trainingPlanId;
        data["FrameworkElementCode"] = this.frameworkElementCode;
        data["Version"] = this.version;
        data["TraineeId"] = this.traineeId;
        data["TraineeFirstName"] = this.traineeFirstName;
        data["TraineeLastName"] = this.traineeLastName;
        data["TraineeNSN"] = this.traineeNSN;
        return data;
    }

    clone(): ResultDto {
        const json = this.toJSON();
        let result = new ResultDto();
        result.init(json);
        return result;
    }
}

export interface IResultDto {
    resultId?: string | undefined;
    dateEntered?: string | undefined;
    dateAchieved?: string | undefined;
    trainingPlanId?: string | undefined;
    frameworkElementCode?: string | undefined;
    version?: number | undefined;
    traineeId?: string | undefined;
    traineeFirstName?: string | undefined;
    traineeLastName?: string | undefined;
    traineeNSN?: string | undefined;
}

export class ApiResultOfCreateResultResponseDto implements IApiResultOfCreateResultResponseDto {
    result?: CreateResultResponseDto | undefined;
    message?: string | undefined;

    constructor(data?: IApiResultOfCreateResultResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.result = data.result && !(data.result as any).toJSON ? new CreateResultResponseDto(data.result) : this.result as CreateResultResponseDto;
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.result = _data["Result"] ? CreateResultResponseDto.fromJS(_data["Result"], _mappings) : undefined as any;
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any, _mappings?: any): ApiResultOfCreateResultResponseDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ApiResultOfCreateResultResponseDto>(data, _mappings, ApiResultOfCreateResultResponseDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : undefined as any;
        data["Message"] = this.message;
        return data;
    }

    clone(): ApiResultOfCreateResultResponseDto {
        const json = this.toJSON();
        let result = new ApiResultOfCreateResultResponseDto();
        result.init(json);
        return result;
    }
}

export interface IApiResultOfCreateResultResponseDto {
    result?: ICreateResultResponseDto | undefined;
    message?: string | undefined;
}

export class SearchScopeResultDto implements ISearchScopeResultDto {
    scopes?: ScopeDto[] | undefined;

    constructor(data?: ISearchScopeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.scopes) {
                this.scopes = [];
                for (let i = 0; i < data.scopes.length; i++) {
                    let item = data.scopes[i];
                    this.scopes[i] = item && !(item as any).toJSON ? new ScopeDto(item) : item as ScopeDto;
                }
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["Scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["Scopes"]) {
                    pushIfNotNull(this.scopes!, ScopeDto.fromJS(item, _mappings));
                }
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SearchScopeResultDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SearchScopeResultDto>(data, _mappings, SearchScopeResultDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scopes)) {
            data["Scopes"] = [];
            for (let item of this.scopes)
                data["Scopes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): SearchScopeResultDto {
        const json = this.toJSON();
        let result = new SearchScopeResultDto();
        result.init(json);
        return result;
    }
}

export interface ISearchScopeResultDto {
    scopes?: IScopeDto[] | undefined;
}

export class ScopeDto implements IScopeDto {
    assessorRegistrationId?: string | undefined;
    assessmentScopeId?: string | undefined;
    supplementaryUnitStandardId?: string | undefined;
    name?: string | undefined;
    parentFrameworkElements?: ParentFrameworkElement[] | undefined;

    constructor(data?: IScopeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.parentFrameworkElements) {
                this.parentFrameworkElements = [];
                for (let i = 0; i < data.parentFrameworkElements.length; i++) {
                    let item = data.parentFrameworkElements[i];
                    this.parentFrameworkElements[i] = item && !(item as any).toJSON ? new ParentFrameworkElement(item) : item as ParentFrameworkElement;
                }
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.assessorRegistrationId = _data["AssessorRegistrationId"];
            this.assessmentScopeId = _data["AssessmentScopeId"];
            this.supplementaryUnitStandardId = _data["SupplementaryUnitStandardId"];
            this.name = _data["Name"];
            if (Array.isArray(_data["ParentFrameworkElements"])) {
                this.parentFrameworkElements = [] as any;
                for (let item of _data["ParentFrameworkElements"]) {
                    pushIfNotNull(this.parentFrameworkElements!, ParentFrameworkElement.fromJS(item, _mappings));
                }
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ScopeDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ScopeDto>(data, _mappings, ScopeDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AssessorRegistrationId"] = this.assessorRegistrationId;
        data["AssessmentScopeId"] = this.assessmentScopeId;
        data["SupplementaryUnitStandardId"] = this.supplementaryUnitStandardId;
        data["Name"] = this.name;
        if (Array.isArray(this.parentFrameworkElements)) {
            data["ParentFrameworkElements"] = [];
            for (let item of this.parentFrameworkElements)
                data["ParentFrameworkElements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ScopeDto {
        const json = this.toJSON();
        let result = new ScopeDto();
        result.init(json);
        return result;
    }
}

export interface IScopeDto {
    assessorRegistrationId?: string | undefined;
    assessmentScopeId?: string | undefined;
    supplementaryUnitStandardId?: string | undefined;
    name?: string | undefined;
    parentFrameworkElements?: IParentFrameworkElement[] | undefined;
}

export class ParentFrameworkElement implements IParentFrameworkElement {
    name?: string | undefined;
    unitStandards?: UnitStandard[] | undefined;

    constructor(data?: IParentFrameworkElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.unitStandards) {
                this.unitStandards = [];
                for (let i = 0; i < data.unitStandards.length; i++) {
                    let item = data.unitStandards[i];
                    this.unitStandards[i] = item && !(item as any).toJSON ? new UnitStandard(item) : item as UnitStandard;
                }
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["Name"];
            if (Array.isArray(_data["UnitStandards"])) {
                this.unitStandards = [] as any;
                for (let item of _data["UnitStandards"]) {
                    pushIfNotNull(this.unitStandards!, UnitStandard.fromJS(item, _mappings));
                }
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ParentFrameworkElement | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ParentFrameworkElement>(data, _mappings, ParentFrameworkElement);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        if (Array.isArray(this.unitStandards)) {
            data["UnitStandards"] = [];
            for (let item of this.unitStandards)
                data["UnitStandards"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ParentFrameworkElement {
        const json = this.toJSON();
        let result = new ParentFrameworkElement();
        result.init(json);
        return result;
    }
}

export interface IParentFrameworkElement {
    name?: string | undefined;
    unitStandards?: IUnitStandard[] | undefined;
}

export class UnitStandard implements IUnitStandard {
    unitStandardId?: string | undefined;
    frameworkElementId?: string | undefined;
    frameworkElementCode?: string | undefined;
    unitStandardName?: string | undefined;
    credits?: number | undefined;
    currentVersion?: number | undefined;
    versions?: string | undefined;
    isLatestVersion?: boolean | undefined;
    readonly entityName?: string | undefined;

    constructor(data?: IUnitStandard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.unitStandardId = _data["UnitStandardId"];
            this.frameworkElementId = _data["FrameworkElementId"];
            this.frameworkElementCode = _data["FrameworkElementCode"];
            this.unitStandardName = _data["UnitStandardName"];
            this.credits = _data["Credits"];
            this.currentVersion = _data["CurrentVersion"];
            this.versions = _data["Versions"];
            this.isLatestVersion = _data["IsLatestVersion"];
            (this as any).entityName = _data["EntityName"];
        }
    }

    static fromJS(data: any, _mappings?: any): UnitStandard | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UnitStandard>(data, _mappings, UnitStandard);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UnitStandardId"] = this.unitStandardId;
        data["FrameworkElementId"] = this.frameworkElementId;
        data["FrameworkElementCode"] = this.frameworkElementCode;
        data["UnitStandardName"] = this.unitStandardName;
        data["Credits"] = this.credits;
        data["CurrentVersion"] = this.currentVersion;
        data["Versions"] = this.versions;
        data["IsLatestVersion"] = this.isLatestVersion;
        data["EntityName"] = this.entityName;
        return data;
    }

    clone(): UnitStandard {
        const json = this.toJSON();
        let result = new UnitStandard();
        result.init(json);
        return result;
    }
}

export interface IUnitStandard {
    unitStandardId?: string | undefined;
    frameworkElementId?: string | undefined;
    frameworkElementCode?: string | undefined;
    unitStandardName?: string | undefined;
    credits?: number | undefined;
    currentVersion?: number | undefined;
    versions?: string | undefined;
    isLatestVersion?: boolean | undefined;
    entityName?: string | undefined;
}

export class TrainingPlanDto implements ITrainingPlanDto {
    contactId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nSN?: string | undefined;
    trainingPlanId?: string | undefined;
    programmeName?: string | undefined;
    isTtafEligible?: boolean | undefined;
    dateOfBirth?: string | undefined;
    status?: string | undefined;

    constructor(data?: ITrainingPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.contactId = _data["ContactId"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.nSN = _data["NSN"];
            this.trainingPlanId = _data["TrainingPlanId"];
            this.programmeName = _data["ProgrammeName"];
            this.isTtafEligible = _data["IsTtafEligible"];
            this.dateOfBirth = _data["DateOfBirth"];
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any, _mappings?: any): TrainingPlanDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TrainingPlanDto>(data, _mappings, TrainingPlanDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContactId"] = this.contactId;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["NSN"] = this.nSN;
        data["TrainingPlanId"] = this.trainingPlanId;
        data["ProgrammeName"] = this.programmeName;
        data["IsTtafEligible"] = this.isTtafEligible;
        data["DateOfBirth"] = this.dateOfBirth;
        data["Status"] = this.status;
        return data;
    }

    clone(): TrainingPlanDto {
        const json = this.toJSON();
        let result = new TrainingPlanDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingPlanDto {
    contactId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nSN?: string | undefined;
    trainingPlanId?: string | undefined;
    programmeName?: string | undefined;
    isTtafEligible?: boolean | undefined;
    dateOfBirth?: string | undefined;
    status?: string | undefined;
}

export class TrainingPlanUnitStandardDto implements ITrainingPlanUnitStandardDto {
    trainingPlanId?: string | undefined;
    trainingPlanUnitStandards?: TrainingPlanUnitStandard[] | undefined;

    constructor(data?: ITrainingPlanUnitStandardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.trainingPlanUnitStandards) {
                this.trainingPlanUnitStandards = [];
                for (let i = 0; i < data.trainingPlanUnitStandards.length; i++) {
                    let item = data.trainingPlanUnitStandards[i];
                    this.trainingPlanUnitStandards[i] = item && !(item as any).toJSON ? new TrainingPlanUnitStandard(item) : item as TrainingPlanUnitStandard;
                }
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.trainingPlanId = _data["TrainingPlanId"];
            if (Array.isArray(_data["TrainingPlanUnitStandards"])) {
                this.trainingPlanUnitStandards = [] as any;
                for (let item of _data["TrainingPlanUnitStandards"]) {
                    pushIfNotNull(this.trainingPlanUnitStandards!, TrainingPlanUnitStandard.fromJS(item, _mappings));
                }
            }
        }
    }

    static fromJS(data: any, _mappings?: any): TrainingPlanUnitStandardDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TrainingPlanUnitStandardDto>(data, _mappings, TrainingPlanUnitStandardDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TrainingPlanId"] = this.trainingPlanId;
        if (Array.isArray(this.trainingPlanUnitStandards)) {
            data["TrainingPlanUnitStandards"] = [];
            for (let item of this.trainingPlanUnitStandards)
                data["TrainingPlanUnitStandards"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TrainingPlanUnitStandardDto {
        const json = this.toJSON();
        let result = new TrainingPlanUnitStandardDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingPlanUnitStandardDto {
    trainingPlanId?: string | undefined;
    trainingPlanUnitStandards?: ITrainingPlanUnitStandard[] | undefined;
}

export class TrainingPlanUnitStandard implements ITrainingPlanUnitStandard {
    trainingPlanUnitStandardId?: string | undefined;
    unitStandardId?: string | undefined;
    unitStandardCode?: string | undefined;
    unitStandardName?: string | undefined;
    resultId?: string | undefined;
    dateAchieved?: string | undefined;
    isRcc?: boolean | undefined;
    version?: number | undefined;
    readonly isExistingResult?: boolean | undefined;
    readonly entityName?: string | undefined;

    constructor(data?: ITrainingPlanUnitStandard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.trainingPlanUnitStandardId = _data["TrainingPlanUnitStandardId"];
            this.unitStandardId = _data["UnitStandardId"];
            this.unitStandardCode = _data["UnitStandardCode"];
            this.unitStandardName = _data["UnitStandardName"];
            this.resultId = _data["ResultId"];
            this.dateAchieved = _data["DateAchieved"];
            this.isRcc = _data["IsRcc"];
            this.version = _data["Version"];
            (this as any).isExistingResult = _data["IsExistingResult"];
            (this as any).entityName = _data["EntityName"];
        }
    }

    static fromJS(data: any, _mappings?: any): TrainingPlanUnitStandard | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<TrainingPlanUnitStandard>(data, _mappings, TrainingPlanUnitStandard);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TrainingPlanUnitStandardId"] = this.trainingPlanUnitStandardId;
        data["UnitStandardId"] = this.unitStandardId;
        data["UnitStandardCode"] = this.unitStandardCode;
        data["UnitStandardName"] = this.unitStandardName;
        data["ResultId"] = this.resultId;
        data["DateAchieved"] = this.dateAchieved;
        data["IsRcc"] = this.isRcc;
        data["Version"] = this.version;
        data["IsExistingResult"] = this.isExistingResult;
        data["EntityName"] = this.entityName;
        return data;
    }

    clone(): TrainingPlanUnitStandard {
        const json = this.toJSON();
        let result = new TrainingPlanUnitStandard();
        result.init(json);
        return result;
    }
}

export interface ITrainingPlanUnitStandard {
    trainingPlanUnitStandardId?: string | undefined;
    unitStandardId?: string | undefined;
    unitStandardCode?: string | undefined;
    unitStandardName?: string | undefined;
    resultId?: string | undefined;
    dateAchieved?: string | undefined;
    isRcc?: boolean | undefined;
    version?: number | undefined;
    isExistingResult?: boolean | undefined;
    entityName?: string | undefined;
}

export class ApiResultOfUnitStandardDto implements IApiResultOfUnitStandardDto {
    result?: UnitStandardDto | undefined;
    message?: string | undefined;

    constructor(data?: IApiResultOfUnitStandardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.result = data.result && !(data.result as any).toJSON ? new UnitStandardDto(data.result) : this.result as UnitStandardDto;
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.result = _data["Result"] ? UnitStandardDto.fromJS(_data["Result"], _mappings) : undefined as any;
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any, _mappings?: any): ApiResultOfUnitStandardDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ApiResultOfUnitStandardDto>(data, _mappings, ApiResultOfUnitStandardDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : undefined as any;
        data["Message"] = this.message;
        return data;
    }

    clone(): ApiResultOfUnitStandardDto {
        const json = this.toJSON();
        let result = new ApiResultOfUnitStandardDto();
        result.init(json);
        return result;
    }
}

export interface IApiResultOfUnitStandardDto {
    result?: IUnitStandardDto | undefined;
    message?: string | undefined;
}

export class UnitStandardDto implements IUnitStandardDto {
    frameworkElementId?: string | undefined;
    unitStandardId?: string | undefined;
    frameworkElementCode?: string | undefined;
    unitStandardName?: string | undefined;
    credits?: number | undefined;
    currentVersion?: number | undefined;
    versions?: string | undefined;
    isLatestVersion?: boolean | undefined;

    constructor(data?: IUnitStandardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.frameworkElementId = _data["FrameworkElementId"];
            this.unitStandardId = _data["UnitStandardId"];
            this.frameworkElementCode = _data["FrameworkElementCode"];
            this.unitStandardName = _data["UnitStandardName"];
            this.credits = _data["Credits"];
            this.currentVersion = _data["CurrentVersion"];
            this.versions = _data["Versions"];
            this.isLatestVersion = _data["IsLatestVersion"];
        }
    }

    static fromJS(data: any, _mappings?: any): UnitStandardDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UnitStandardDto>(data, _mappings, UnitStandardDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FrameworkElementId"] = this.frameworkElementId;
        data["UnitStandardId"] = this.unitStandardId;
        data["FrameworkElementCode"] = this.frameworkElementCode;
        data["UnitStandardName"] = this.unitStandardName;
        data["Credits"] = this.credits;
        data["CurrentVersion"] = this.currentVersion;
        data["Versions"] = this.versions;
        data["IsLatestVersion"] = this.isLatestVersion;
        return data;
    }

    clone(): UnitStandardDto {
        const json = this.toJSON();
        let result = new UnitStandardDto();
        result.init(json);
        return result;
    }
}

export interface IUnitStandardDto {
    frameworkElementId?: string | undefined;
    unitStandardId?: string | undefined;
    frameworkElementCode?: string | undefined;
    unitStandardName?: string | undefined;
    credits?: number | undefined;
    currentVersion?: number | undefined;
    versions?: string | undefined;
    isLatestVersion?: boolean | undefined;
}

export class ApiResultOfUnitStandardVersionsDto implements IApiResultOfUnitStandardVersionsDto {
    result?: UnitStandardVersionsDto | undefined;
    message?: string | undefined;

    constructor(data?: IApiResultOfUnitStandardVersionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.result = data.result && !(data.result as any).toJSON ? new UnitStandardVersionsDto(data.result) : this.result as UnitStandardVersionsDto;
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.result = _data["Result"] ? UnitStandardVersionsDto.fromJS(_data["Result"], _mappings) : undefined as any;
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any, _mappings?: any): ApiResultOfUnitStandardVersionsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ApiResultOfUnitStandardVersionsDto>(data, _mappings, ApiResultOfUnitStandardVersionsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : undefined as any;
        data["Message"] = this.message;
        return data;
    }

    clone(): ApiResultOfUnitStandardVersionsDto {
        const json = this.toJSON();
        let result = new ApiResultOfUnitStandardVersionsDto();
        result.init(json);
        return result;
    }
}

export interface IApiResultOfUnitStandardVersionsDto {
    result?: IUnitStandardVersionsDto | undefined;
    message?: string | undefined;
}

export class UnitStandardVersionsDto implements IUnitStandardVersionsDto {
    frameworkElementCode?: string | undefined;
    versions?: VersionDto[] | undefined;

    constructor(data?: IUnitStandardVersionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.versions) {
                this.versions = [];
                for (let i = 0; i < data.versions.length; i++) {
                    let item = data.versions[i];
                    this.versions[i] = item && !(item as any).toJSON ? new VersionDto(item) : item as VersionDto;
                }
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.frameworkElementCode = _data["FrameworkElementCode"];
            if (Array.isArray(_data["Versions"])) {
                this.versions = [] as any;
                for (let item of _data["Versions"]) {
                    pushIfNotNull(this.versions!, VersionDto.fromJS(item, _mappings));
                }
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UnitStandardVersionsDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UnitStandardVersionsDto>(data, _mappings, UnitStandardVersionsDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FrameworkElementCode"] = this.frameworkElementCode;
        if (Array.isArray(this.versions)) {
            data["Versions"] = [];
            for (let item of this.versions)
                data["Versions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UnitStandardVersionsDto {
        const json = this.toJSON();
        let result = new UnitStandardVersionsDto();
        result.init(json);
        return result;
    }
}

export interface IUnitStandardVersionsDto {
    frameworkElementCode?: string | undefined;
    versions?: IVersionDto[] | undefined;
}

export class VersionDto implements IVersionDto {
    unitStandardId?: string | undefined;
    version?: number | undefined;

    constructor(data?: IVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.unitStandardId = _data["UnitStandardId"];
            this.version = _data["Version"];
        }
    }

    static fromJS(data: any, _mappings?: any): VersionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<VersionDto>(data, _mappings, VersionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UnitStandardId"] = this.unitStandardId;
        data["Version"] = this.version;
        return data;
    }

    clone(): VersionDto {
        const json = this.toJSON();
        let result = new VersionDto();
        result.init(json);
        return result;
    }
}

export interface IVersionDto {
    unitStandardId?: string | undefined;
    version?: number | undefined;
}

export type CreateResultResponseDtoCrmSaveStatus = 0 | 1;

function jsonParse(json: any, reviver?: any) {
    json = JSON.parse(json, reviver);

    var byid: any = {};
    var refs: any = [];
    json = (function recurse(obj: any, prop?: any, parent?: any) {
        if (typeof obj !== 'object' || !obj)
            return obj;
        
        if ("$ref" in obj) {
            let ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        } else if ("$id" in obj) {
            let id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }
        
        if (Array.isArray(obj)) {
            obj = obj.map((v, i) => recurse(v, i, obj));
        } else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }

        return obj;
    })(json);

    for (let i = 0; i < refs.length; i++) {
        const ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }

    return json;
}

function createInstance<T>(data: any, mappings: any, type: any): T | null {
  if (!mappings)
    mappings = [];
  if (!data)
    return null;

  const mappingIndexName = "__mappingIndex";
  if (data[mappingIndexName])
    return <T>mappings[data[mappingIndexName]].target;

  data[mappingIndexName] = mappings.length;

  let result: any = new type();
  mappings.push({ source: data, target: result });
  result.init(data, mappings);
  return result;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

function pushIfNotNull<T>(target: T[], value: T | null | undefined): void {
    if (value !== null && value !== undefined) {
        target.push(value);
    }
}